import ChannelConfigurationConverter from 'scripts/application/dto_converters/channel_configuration_converter';
import qconsole from 'scripts/lib/qconsole';

export default class ChannelConfigurationGatewayObserver {
  constructor(context) {
    this.context = context;
  }

  onFetchSuccess(channelConfigurationDto) {
    this.context.stores.channelConfiguration.set(ChannelConfigurationConverter.fromDto(channelConfigurationDto));
  }

  onFetchError(errorDto) {
    qconsole.log(`Failed to fetch endpoints ${JSON.stringify(errorDto)}`);
  }

  onBroadcast(channelConfigurationDto) {
    this.context.stores.channelConfiguration.set(ChannelConfigurationConverter.fromDto(channelConfigurationDto));
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/configuration/channel_configuration_gateway_observer.js